function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTheWeatherNetworkLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1000,
    height: 239.289,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0a3.253 3.253 0 0 1 3.244-3.244h23.215A3.253 3.253 0 0 1 29.703 0v23.744a3.253 3.253 0 0 1-3.244 3.244H3.244A3.253 3.253 0 0 1 0 23.744z",
    style: {
      fill: "#feec36",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(7.88201 0 0 -7.88201 .5 213.22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0 .389.088.814.249 1.264 4.172 2.488 8.525 6.313 10.504 9.323q.125.012.238.012c.58 0 .959-.364.959-.818C11.95 7.01 4.918.884.155-.94.057-.702 0-.398 0 0m10.285 10.507C8.344 7.849 4.456 4.613.778 2.408c1.882 3.368 6.733 7.44 9.507 8.099M-4.228.099q-.006.05-.007.102c0 .827.318 1.792.861 2.823C.355 4.893 4.256 7.899 6.94 10.789c1.228 1.318 2.2 2.612 2.79 3.763q.327.067.607.069c1.059 0 1.209-.756 1.209-1.261 0-.694-.371-1.552-1.008-2.493a4 4 0 0 1-.422-.078C7.01 10.066 1.378 5.539-.545 1.655-1.873.942-3.136.396-4.228.099m3.075-1.441a5 5 0 0 0-1.015-.121c-.662 0-1.341.24-1.734.717.92.321 1.904.769 2.913 1.31A4.5 4.5 0 0 1-1.21-.757q.002-.323.057-.585M-5.48-.135a4 4 0 0 0-.369-.017c-1.243 0-1.865.622-2.024 1.52.991.205 2.048.558 3.135 1.023-.416-.879-.678-1.73-.742-2.526m-3.601 2.564c-1.18.091-1.709.817-1.709 1.806q0 .173.016.355c.938.107 1.95.375 3.001.771-.614-1.03-1.067-2.022-1.308-2.932m-2.634 3.472c-.941.322-1.092 1.091-1.092 1.712q0 .414.12.892.255-.033.536-.035c.586 0 1.241.116 1.942.325-.648-1.004-1.166-1.982-1.506-2.894m-1.704 4.888a2.5 2.5 0 0 0-.093.706c0 .443.125.949.349 1.496a2.5 2.5 0 0 1 1.113-.235q.321 0 .663.048a23 23 0 0 1-1.401-2.015 16 16 0 0 1-.327-.561 1.46 1.46 0 0 0-.304.561M-.378 24.024c.655 0 .983-.352.983-.856q0-.218-.06-.462c-3.394-1.448-7.95-5.152-11.099-8.874a3.4 3.4 0 0 0-.639-.069c-.622 0-1.095.105-1.421.324 2.454 4.225 9.285 9.937 12.236 9.937m-8.867-9.794c2.763 3.291 6.623 6.604 9.648 8.053-1.073-2.618-6.201-6.686-9.648-8.053m12.321 8.812c1.008 0 1.311-.253 1.311-1.211 0-.23-.071-.503-.2-.81-3.859-1.198-9.424-5.724-12.966-10.232a30 30 0 0 1-.54-.709c-.8-.257-1.552-.4-2.227-.4q-.381-.001-.696.07.228.502.533 1.039c.423.736.947 1.512 1.55 2.302C-5.862 14.468-.17 19.739.772 22.452c.862.377 1.646.59 2.304.59M-7.901 10.627q.057.081.118.162c3.14 4.185 8.109 8.459 11.76 9.804-1.507-2.771-6.908-7.629-11.526-9.804zM6.05 21.025c1.009 0 1.463-.505 1.463-1.261 0-.498-.192-1.087-.536-1.737-2.958-.889-7.067-3.844-10.412-7.238-1.322-1.34-2.525-2.748-3.489-4.124-1.348-.562-2.594-.897-3.624-.915.312 1.085.917 2.296 1.724 3.55.916.388 1.881.897 2.856 1.489 4.456 2.708 9.136 7.17 10.353 9.943.603.19 1.162.293 1.665.293M-5.414 7.363a34 34 0 0 0 2.931 3.426c2.986 3.081 6.606 5.839 9.242 6.85-1.231-2.056-3.835-4.626-6.775-6.85-1.754-1.325-3.626-2.528-5.398-3.426m14.677 7.065c-.678-1.12-1.75-2.373-3.06-3.639C3.787 8.456.559 6.086-2.502 4.467c1.466 2.16 3.676 4.46 5.916 6.322 2.132 1.773 4.287 3.151 5.849 3.639m-.666 3.622c1.009 0 1.462-.681 1.462-1.387 0-.535-.206-1.163-.577-1.852-1.699-.413-4.317-1.958-6.893-4.022-2.555-2.045-5.066-4.6-6.595-7.062-1.39-.628-2.708-1.066-3.854-1.231.163 1.012.693 2.196 1.478 3.45 2.501 1.16 5.123 2.92 7.426 4.843 2.839 2.369 5.187 4.986 6.224 7.027.489.153.936.234 1.329.234M1.563-1.715c-.251 0-.496.025-.715.101C5.988.873 12.252 6.891 12.252 9.73c0 .525-.272.894-.734 1.059a1.8 1.8 0 0 1-.575.099c.577.937.907 1.785.907 2.472 0 .505-.152 1.564-1.565 1.564q-.181-.001-.39-.031c.302.66.466 1.268.466 1.795 0 1.135-.755 1.613-1.764 1.613a5.2 5.2 0 0 1-1.169-.15c.267.591.413 1.128.413 1.588 0 .857-.454 1.587-1.892 1.587-.43 0-.905-.071-1.413-.205q.153.445.153.811c0 .958-.605 1.411-1.613 1.411-.63 0-1.375-.178-2.198-.499q.03.156.03.298c0 .756-.403 1.16-1.361 1.16-3.148 0-9.58-4.928-12.677-9.384a2 2 0 0 0-.029.358c0 1.714 2.167 5.647 7.663 8.168l-.151.303c-5.797-2.396-8.597-7.008-8.597-8.924 0-.415.106-.821.325-1.163-.578-1.039-.927-2.022-.953-2.871q-.002-.052-.002-.1c0-.814.389-1.471 1.092-1.854-.281-.717-.437-1.385-.437-1.978 0-.741.554-2.076 2.128-2.29a5 5 0 0 1-.085-.887c0-1.059.732-2.521 2.444-2.521q.225 0 .458.014-.003-.057-.004-.115c0-1.613 1.111-2.37 2.572-2.37.405 0 .844.051 1.308.145.344-1.088 1.52-1.557 2.373-1.557.701 0 1.502.171 2.362.474.387-.344.954-.474 1.62-.474 2.522 0 7.514 3.076 9.732 7.059l-.202.202C7.739.352 3.454-1.715 1.563-1.715",
    style: {
      fill: "#173a79",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(7.88201 0 0 -7.88201 127.894 204.683)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-10.419h-2.462V0h-3.296v2.196h9.054V0z",
    style: {
      fill: "#173a79",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(7.88201 0 0 -7.88201 300.591 30.452)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v5.634c0 1.223-.781 1.63-1.506 1.63-.727 0-1.489-.425-1.489-1.63V0h-2.304v12.615h2.304V8.38c.62.639 1.4.958 2.214.958 2.021 0 3.084-1.418 3.084-3.367V0z",
    style: {
      fill: "#173a79",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(7.88201 0 0 -7.88201 377.126 112.57)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.248.549-.763.957-1.541.957-.78 0-1.294-.408-1.542-.957a2.55 2.55 0 0 1-.213-.993H.213A2.55 2.55 0 0 1 0 0m-3.296-2.57c0-1.187.726-2.055 2.021-2.055 1.009 0 1.505.283 2.09.868l1.4-1.365C1.276-6.06.373-6.574-1.293-6.574c-2.179 0-4.27.992-4.27 4.73 0 3.013 1.629 4.714 4.022 4.714 2.569 0 4.022-1.878 4.022-4.412V-2.57z",
    style: {
      fill: "#173a79",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(7.88201 0 0 -7.88201 448.063 61.59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-2.056l-2.321 7.655L-6.698 0h-2.055l-3.367 12.615h2.569l1.95-7.955 2.304 7.955h1.842l2.304-7.955 1.966 7.955h2.569z",
    style: {
      fill: "#173a79",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(7.88201 0 0 -7.88201 591.721 112.57)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.248.549-.762.957-1.541.957-.78 0-1.295-.408-1.542-.957a2.55 2.55 0 0 1-.213-.993H.212A2.5 2.5 0 0 1 0 0m-3.296-2.57c0-1.187.728-2.055 2.02-2.055 1.01 0 1.507.283 2.091.868l1.399-1.365C1.275-6.06.373-6.574-1.294-6.574c-2.179 0-4.27.992-4.27 4.73 0 3.013 1.631 4.714 4.023 4.714 2.569 0 4.022-1.878 4.022-4.412V-2.57z",
    style: {
      fill: "#173a79",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(7.88201 0 0 -7.88201 659.59 61.59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-1.826c-.832 0-1.292-.389-1.292-1.046 0-.637.424-1.063 1.328-1.063.638 0 1.045.054 1.452.444.249.23.338.603.338 1.169zm.053-3.898v.797c-.62-.619-1.205-.885-2.269-.885-1.045 0-1.806.266-2.356.815-.496.514-.762 1.258-.762 2.072 0 1.471 1.01 2.676 3.154 2.676H0v.461c0 1.01-.496 1.453-1.719 1.453-.886 0-1.294-.213-1.772-.763l-1.471 1.436c.904.992 1.791 1.276 3.332 1.276 2.587 0 3.933-1.099 3.933-3.26v-6.078z",
    style: {
      fill: "#173a79",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(7.88201 0 0 -7.88201 727.74 81.848)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-1.878 0-2.676 1.329-2.676 2.64v4.571h-.974v1.755h.974v2.728h2.304V8.966h1.63V7.211h-1.63V2.782c0-.532.248-.833.797-.833h.833V0z",
    style: {
      fill: "#173a79",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(7.88201 0 0 -7.88201 782.622 112.57)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v5.634c0 1.223-.78 1.63-1.507 1.63s-1.488-.425-1.488-1.63V0h-2.304v12.615h2.304V8.38c.62.639 1.401.958 2.215.958 2.02 0 3.083-1.418 3.083-3.367V0z",
    style: {
      fill: "#173a79",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(7.88201 0 0 -7.88201 844.63 112.57)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.249.549-.763.957-1.541.957-.78 0-1.294-.408-1.542-.957a2.55 2.55 0 0 1-.213-.993H.213A2.55 2.55 0 0 1 0 0m-3.296-2.57c0-1.187.727-2.055 2.021-2.055 1.01 0 1.505.283 2.09.868l1.4-1.365C1.276-6.06.372-6.574-1.293-6.574c-2.18 0-4.271.992-4.271 4.73 0 3.013 1.63 4.714 4.023 4.714 2.569 0 4.022-1.878 4.022-4.412V-2.57z",
    style: {
      fill: "#173a79",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(7.88201 0 0 -7.88201 916.266 61.59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.355.354-.656.548-1.223.548-.708 0-1.488-.531-1.488-1.7v-5.564h-2.304v9.232h2.251V1.63c.443.531 1.328.992 2.321.992.903 0 1.542-.231 2.179-.868z",
    style: {
      fill: "#173a79",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(7.88201 0 0 -7.88201 985.817 59.635)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-4.997 7.743V0H-7.46v12.616h2.198L-.266 4.89v7.726h2.463V0z",
    style: {
      fill: "#173a79",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(7.88201 0 0 -7.88201 318.885 226.127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.249.549-.763.957-1.542.957S-2.835.549-3.083 0a2.55 2.55 0 0 1-.213-.993H.213A2.55 2.55 0 0 1 0 0m-3.296-2.57c0-1.187.726-2.055 2.02-2.055 1.01 0 1.506.284 2.091.868l1.4-1.364C1.276-6.06.373-6.574-1.294-6.574c-2.179 0-4.27.992-4.27 4.73 0 3.013 1.63 4.714 4.022 4.714 2.57 0 4.023-1.878 4.023-4.412V-2.57z",
    style: {
      fill: "#173a79",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(7.88201 0 0 -7.88201 391.228 175.146)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-1.878 0-2.675 1.328-2.675 2.64v4.572h-.975v1.754h.975v2.728h2.303V8.966h1.629V7.212H-.372v-4.43c0-.532.248-.833.797-.833h.832V0z",
    style: {
      fill: "#173a79",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(7.88201 0 0 -7.88201 445.411 226.127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-1.897l-1.93 5.795L-5.759 0h-1.896l-2.835 9.231h2.445l1.489-5.705 1.878 5.705h1.683l1.896-5.705L.39 9.231h2.427z",
    style: {
      fill: "#173a79",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(7.88201 0 0 -7.88201 541.913 226.127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.266.266-.621.407-1.081.407S-1.879.266-2.144 0c-.48-.478-.532-1.275-.532-2.233 0-.956.052-1.772.532-2.249.265-.267.603-.409 1.063-.409s.815.142 1.081.409c.477.477.531 1.293.531 2.249C.531-1.275.477-.478 0 0m1.79-5.83C1.222-6.432.283-6.963-1.081-6.963s-2.286.531-2.853 1.133c-.833.869-1.045 1.914-1.045 3.597 0 1.665.212 2.711 1.045 3.58.567.602 1.489 1.134 2.853 1.134s2.303-.532 2.871-1.134c.831-.869 1.044-1.915 1.044-3.58 0-1.683-.213-2.728-1.044-3.597",
    style: {
      fill: "#173a79",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(7.88201 0 0 -7.88201 605.45 172.077)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.354.355-.656.549-1.223.549-.707 0-1.488-.532-1.488-1.7v-5.565h-2.304v9.232h2.251V1.63c.443.532 1.329.992 2.321.992.903 0 1.542-.23 2.179-.868z",
    style: {
      fill: "#173a79",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(7.88201 0 0 -7.88201 676.67 173.196)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-2.267 3.845-.976-1.098V0h-2.303v11.701h2.303V5.458l3.066 3.773h2.781l-3.295-3.72L2.853 0z",
    style: {
      fill: "#173a79",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(7.88201 0 0 -7.88201 737.977 226.127)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheWeatherNetworkLogo);
export default __webpack_public_path__ + "static/media/the-weather-network-logo.848280e443d9e1b8e97fc1f020c29c5e.svg";
export { ForwardRef as ReactComponent };